import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0adfc80a")

_pushScopeId("data-v-0adfc80a")
const _hoisted_1 = { class: "m-page-header" }
const _hoisted_2 = {
  key: 0,
  class: "only-title"
}
const _hoisted_3 = {
  key: 1,
  class: "link-header"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.type === 'text')
      ? (_openBlock(), _createBlock("h5", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : (_ctx.type === 'link')
        ? (_openBlock(), _createBlock("h5", _hoisted_3, [
            (_ctx.router)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: _ctx.getRoute(_ctx.router),
                  class: "m-page-header-iconfont icon-fanhui1 back-btn"
                }, null, 8, ["to"]))
              : (_openBlock(), _createBlock("div", {
                  key: 1,
                  class: "m-page-header-iconfont icon-fanhui1 back-btn",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                })),
            _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
          ]))
        : _createCommentVNode("", true)
  ]))
})